import { GetServerSideProps, NextPage } from 'next';

import Head from '@wetransfer/transfer-new/components/Head';
import getMetadata from '@wetransfer/transfer/api/metadata';
import ClientSideApp from '@wetransfer/transfer/ClientSideApplication';
import fetchInitialData, {
  InitialData,
} from '@wetransfer/transfer/helper/fetchInitialData';
import setLocaleFromRequest from '@wetransfer/transfer/helper/setLocaleFromRequest';
import useTransferOpenGraph from '@wetransfer/transfer/hooks/useTransferOpenGraph';

interface PageProps {
  metadata: {
    id: string;
    title: string;
    files_count: number;
  } | null;
  securityHash?: string;
  data: InitialData;
}

export const getServerSideProps: GetServerSideProps<
  PageProps,
  { transferId: string; recipientId: string; securityHash: string }
> = async ({ params, req }) => {
  setLocaleFromRequest(req);

  const initialData = await fetchInitialData(req);

  if (initialData?.redirect) {
    return {
      redirect: {
        ...initialData.redirect,
      },
    };
  }

  if (params === undefined) {
    return {
      props: {
        metadata: null,
        data: initialData,
      },
    };
  }

  const metadata = await getMetadata({
    transferId: params.transferId,
    securityHash: params.securityHash,
    recipientId: params.recipientId,
  });

  return {
    props: {
      metadata,
      securityHash: params.securityHash,
      data: initialData,
    },
  };
};

const Download: NextPage<PageProps> = ({ metadata, securityHash, data }) => {
  const openGraph = useTransferOpenGraph({ metadata, securityHash });

  return (
    <>
      <Head openGraph={openGraph} />;
      <ClientSideApp data={data} />
    </>
  );
};

export default Download;
